import { createStore } from 'vuex'

export default createStore({
  state: {
    cname: 'pc'
  },
  mutations: {
    setCname(url) {
      this.state.cname = url
    }
  },
  actions: {
  },
  modules: {
  }
})
